<template>
  <!--
      作者 luoyiming
      时间：2020-08-30
      描述：设置-满额包邮
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <div class="common-form">满额包邮设置</div>

      <el-form-item label="是否开启满额包邮">
        <div>
          <el-radio v-model="form.is_open" :label="1">开启</el-radio>
          <el-radio v-model="form.is_open" :label="0">关闭</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="单笔订单满" prop="money" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.money" type="number" style="width: 200px;"></el-input>元
        <div class="tips">
          如果开启满额包邮，设置0为全场包邮
        </div>
      </el-form-item>
      <el-form-item label="例外商品：">
        <div class="max-w680">
          <div class="ww100">
            <el-button type="primary" @click="openProduct" class="mb16">选择商品</el-button>
          </div>
          <div v-if="productList && productList.length > 0" class="max-w680 d-s-s mt16" style="flex-wrap: wrap;">
            <div v-for="(item, index) in productList" :key="index" class="imgItem pr mr10">
              <img v-bind:src="item.product_image" width="50" height="50"/>
              <div class="bottom-shade">
                <i class="el-icon-delete" @click="deleteFunc(index, item.product_id)"></i>
              </div>
              <p class="text-ellipsis" style="width: 80px;">{{ item.product_id }}</p>
              <p class="text-ellipsis" style="width: 80px;">{{ item.product_name }}</p>
            </div>
          </div>
        </div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--产品列表弹出层组件-->
    <Product :isproduct="isProduct" @closeDialog="closeDialogFunc($event)" :islist="isList" :excludeIds="form.notin_product">产品列表弹出层</Product>
  </div>

</template>

<script>
import SettingApi from '@/api/setting.js'
import Product from '@/components/product/Product.vue'
import _ from 'lodash'

export default {
    components: {
      /*产品列表组件*/
      Product,
    },
    data() {
      return {
        form: {
          is_open: '',
          money: '',
          notin_product: [],
        },
        loading: false,
        isProduct: false,
        isList: true,
        productList: [],
      };
    },
    created() {
      this.getData()
    },

    methods: {
      getData() {
        let self = this;
        SettingApi.fullfreeDetail({}, true)
          .then(data => {
            let vars = data.data.vars.values;
            self.form.is_open = vars.is_open;
            self.form.money = vars.money;
            self.productList = data.data.productList;
          })
          .catch(error => {});
      },
      //提交表单
      onSubmit() {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.editFullfree(params, true)
              .then(data => {
                self.loading = false;
                ElMessage({
                  message: '恭喜你，设置成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
      /*产品列表弹出层*/
      openProduct() {
        this.isProduct = true
      },
      /*关闭弹窗*/
      closeDialogFunc(e) {
        let self = this
        this.isProduct = false
        if (e.type == 'success') {
          let neededFields = ['product_name', 'product_id', 'product_image']
          if (self.isList) {
            console.log("productList", self.productList)
            let mapped = _.map(e.params, _.partialRight(_.pick, neededFields))
            if (self.productList && self.productList.length > 0) {
              self.productList = self.productList.concat(mapped)
            } else {
              self.productList = mapped
            }
          } else {
            self.productList = _.pick(e.params, neededFields)
          }
          self.productList = _.uniqBy(self.productList, 'product_id')
          self.form.notin_product = self.productList.map(item => item.product_id)
        }
      },
      /*删除商品*/
      deleteFunc(i, product_id) {
        let self = this
        self.productList.splice(i, 1);
        _.remove(self.form.notin_product, function (n) {
          return n == product_id
        })
      },
    }

  };
</script>

<style scoped>
  .tips {
    color: #ccc;
  }
  .delete-btn {
    position: absolute;
    display: block;
    width: 20px;
    height: 20px;
    line-height: 20px;
    right: -8px;
    top: -8px;
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/fullfree/index.vue